import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { Hidden } from 'ui-components/common/Hidden';
import { Link } from 'ui-components/common/Link';

export interface SubMenuProps<K extends string> {
  className?: string;
  menuList: K[];
  menuPath: Record<K, string>;
  menuText: Record<K, string>;
  selectedMenu: K;
}

export const LineSubMenu = <K extends string>({
  className,
  menuList,
  menuPath,
  menuText,
  selectedMenu,
}: SubMenuProps<K>) => {
  const HiddenUl = Hidden.withComponent('ul');

  return (
    <>
      <HiddenUl>
        {menuList.map(menu => (
          <li key={menu}>
            <Link key={menu} href={menuPath[menu]}>
              {menuText[menu]}
            </Link>
          </li>
        ))}
      </HiddenUl>
      <StyledMenu className={className}>
        {menuList.map(menu => (
          <Link key={menu} href={menuPath[menu]}>
            <StyledContainer isSelected={selectedMenu === menu}>{menuText[menu]}</StyledContainer>
          </Link>
        ))}
      </StyledMenu>
    </>
  );
};

const StyledMenu = styled.section`
  display: flex;
  width: 100%;
  justify-content: left;
  gap: 32px;
  margin: auto;
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const StyledContainer = styled.p(
  ({ isSelected }: { isSelected?: boolean }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px 0;
    text-wrap: nowrap;

    height: 100%;
    color: ${isSelected ? Color.Primary500 : 'initial'};
    font-weight: ${isSelected ? FontWeight.Bold : FontWeight.Regular};
    ${Typography.XSmall};

    ${isSelected &&
    css`
      box-shadow: 0px -3px 0px 0px ${Color.Primary500} inset;
    `}
  `,
);
